import classNames from 'classnames';
import { Checkbox } from 'primereact/checkbox';
import { CheckMarkIcon } from '@ds-icons';
import { ICheckboxSelections } from './CheckboxSelections.types';
import styles from './CheckboxSelections.module.scss';

export const CheckboxSelections: React.FC<ICheckboxSelections> = ({
  title,
  options,
  onCheckboxChanged,
  className = '',
  disabled = false,
}: ICheckboxSelections) => {
  return (
    <div className={classNames(className, styles['ds-checkbox-selections-container'])}>
      {title && <div className={styles['title']}>{title}</div>}
      <div className={styles['checkbox-options-container']}>
        {options.map((option, index) => (
          <div
            className={classNames(styles['checkbox-option'], { disabled: option.disabled })}
            key={`checkbox-${index}`}
          >
            <Checkbox
              icon={<img src={CheckMarkIcon} className={styles['checkmark']} />}
              value={option.label}
              checked={option.checked}
              disabled={option.disabled || disabled}
              key={index}
              onChange={(event) => {
                onCheckboxChanged(index, event.checked ?? false);
              }}
            />
            <label className="ml-2">{option.label}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
